<h1 mat-dialog-title translate> dialog.login_forced.title </h1>
<div class="modal-body" mat-dialog-content>
  <p  [innerHTML]="'dialog.login_forced.body' | translate: {username: data.username}"></p>
</div>
<div class="modal-footer" mat-dialog-actions>
  <button type="button" class="btn btn-outline-danger" (click)="cancell()" translate>
    dialog.login_forced.cancell
  </button>
  <button type="button" class="btn btn-outline-secondary" (click)="continue()" translate>
    dialog.login_forced.confirm
  </button>
</div>